
export const OPEN_PDF_VIEWER = "OPEN_PDF_VIEWER";
export const CLOSE_PDF_VIEWER = "CLOSE_PDF_VIEWER";
